import { db } from "@/main";

import { DB } from "@/common/store";
import {
  CHECKOUT,
  FECALYSIS,
  GetLastSubmission,
  PHOTO,
  TEMPERATURE,
  URINALYSIS,
  XRAY
} from "@/store/offsiteService";

function GenerateStructure(scheduleId, userCode, type, content) {
  return {
    ...content,

    scheduleId: scheduleId,
    userCode: userCode,
    type: type,
    timestamp: new Date()
  };
}

export function AddPhoto(scheduleId, userCode, photo) {
  return new Promise((resolve, reject) => {
    db.collection(DB.OFFSITE_SUBMISSIONS)
      .add(GenerateStructure(scheduleId, userCode, PHOTO, { photo: photo }))
      .then(() => resolve())
      .catch(err => reject(err));
  });
}

export function AddTemperature(scheduleId, userCode, temperature) {
  return new Promise((resolve, reject) => {
    db.collection(DB.OFFSITE_SUBMISSIONS)
      .add(
        GenerateStructure(scheduleId, userCode, TEMPERATURE, {
          temperature: temperature
        })
      )
      .then(() => resolve())
      .catch(err => reject(err));
  });
}

export function Checkout(scheduleId, userCode, fecalysis, urinalysis, xray) {
  return new Promise((resolve, reject) => {
    db.collection(DB.OFFSITE_SUBMISSIONS)
      .add(
        GenerateStructure(scheduleId, userCode, CHECKOUT, {
          fecalysis: fecalysis,
          urinalysis: urinalysis,
          xray: xray
        })
      )
      .then(() => resolve())
      .catch(err => reject(err));
  });
}

function processSnapshot(snapshot) {
  let submissions = {
    fecalysis: false,
    photo: "",
    temperature: "",
    urinalysis: false,
    xray: false
  };

  snapshot.forEach(doc => {
    const data = doc.data();
    if (FECALYSIS === data.type) {
      submissions.fecalysis = true;
    } else if (PHOTO === data.type) {
      submissions.photo = data.photo;
    } else if (TEMPERATURE === data.type) {
      submissions.temperature = data.temperature;
    } else if (URINALYSIS === data.type) {
      submissions.urinalysis = true;
    } else if (XRAY === data.type) {
      submissions.xray = true;
    }
  });

  return submissions;
}

export function GetCheckinData(scheduleId, userCode) {
  return new Promise((resolve, reject) => {
    db.collection(DB.OFFSITE_SUBMISSIONS)
      .where("scheduleId", "==", scheduleId)
      .where("userCode", "==", userCode)
      .get()
      .then(snapshot => resolve(processSnapshot(snapshot)))
      .catch(err => reject(err));
  });
}

function lastPhoto(snapshot) {
  let lastSubmission = null;
  let photo = "";

  snapshot.forEach(doc => {
    const data = doc.data();
    if (!lastSubmission || lastSubmission < data.timestamp) {
      lastSubmission = data.timestamp;
      photo = data.photo;
    }
  });

  return { photo: photo };
}

function lastTemperature(snapshot) {
  let lastSubmission = null;
  let temperature = "";

  snapshot.forEach(doc => {
    const data = doc.data();
    if (!lastSubmission || lastSubmission < data.timestamp) {
      lastSubmission = data.timestamp;
      temperature = data.temperature;
    }
  });

  return { temperature: temperature };
}

export function GetPhoto(scheduleId, userCode) {
  return GetLastSubmission(scheduleId, userCode, PHOTO, lastPhoto);
}

export function GetTemperature(scheduleId, userCode) {
  return GetLastSubmission(scheduleId, userCode, TEMPERATURE, lastTemperature);
}

export function GetUserDetails(userCode) {
  return new Promise((resolve, reject) => {
    db.collection(DB.OFFSITE_ATTENDEE)
      .where("user.code", "==", userCode)
      .get()
      .then(snapshot => {
        let details = {};

        snapshot.forEach(doc => {
          let data = doc.data();
          details = {
            age: data.user.age,
            birthday: data.user.birthday,
            firstname: data.user.firstName,
            gender: data.user.gender,
            lastName: data.user.lastName
          };
        });

        resolve(details);
      })
      .catch(err => reject(err));
  });
}
